import { TCompanyState } from '@/redux/reducers/company';
import { TCreateCheckoutSessionSuccess } from '@/redux/actions/company';

export const createCheckoutSessionUpdateState = (
  state: TCompanyState,
  action: TCreateCheckoutSessionSuccess,
): TCompanyState => {
  const updatedState = {
    ...state,
    createCheckoutSessionResponse: action.payload.response,
  };
  return updatedState;
};
